import { Injectable } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { bufferCount, filter, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FontSyncService {
  contextList: Record<string, number> = {};
  listeners: Record<string, Subject<number>> = {};
  state: Record<string, Observable<number[]>> = {};

  constructor() {}

  registerContext(context: string, size) {
    this.contextList[context] = size;
    this.listeners[context] = new Subject<number>();

    this.state[context] = this.listeners[context].pipe(bufferCount(size));
    return this.state[context].pipe(
      map((x) => Math.min(...x)),
      tap((x) => console.log('SET NEW FONT', x)),
    );
  }

  reportResult(context: string, result: number) {
    this.listeners[context]?.next(result);
  }

  everythingCompleted() {
    return combineLatest(
      Object.values(this.state).map((v) =>
        v.pipe(
          filter((fontSizes) =>
            fontSizes.every((val, i, all) => val === all[0]),
          ),
        ),
      ),
    );
  }
}
